import { render } from "./Rules.vue?vue&type=template&id=67bfbf42"
import script from "./Rules.vue?vue&type=script&lang=js"
export * from "./Rules.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/rules/Rules.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67bfbf42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67bfbf42', __exports__)) {
    api.reload('67bfbf42', __exports__)
  }
  
  module.hot.accept("./Rules.vue?vue&type=template&id=67bfbf42", () => {
    api.rerender('67bfbf42', render)
  })

}


export default __exports__